"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentsOnboarding = void 0;
var react_1 = __importStar(require("react"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var styles = __importStar(require("./PaymentsOnboarding.css"));
var Configuration_1 = require("@CommonFrontend/Styles/Configuration/Configuration");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var LocationFlag_1 = require("Common/LocationFlag/LocationFlag");
var Countries_1 = require("./Countries");
var inversify_react_1 = require("inversify-react");
var OAuthWindow_1 = __importDefault(require("@CommonFrontend/OAuth/OAuthWindow"));
var axios_1 = __importDefault(require("axios"));
var ModalContainer_1 = require("@CommonFrontend/Modal/ModalContainer");
var usePaymentGateways_1 = require("Library/PaymentsDashboard/PaymentSettings/usePaymentGateways");
function PaymentsOnboarding(_a) {
    var _this = this;
    var closeModal = _a.closeModal, showModal = _a.showModal, telemetry = _a.telemetry;
    var _b = __read((0, react_1.useState)("initial"), 2), step = _b[0], setStep = _b[1];
    var _c = __read((0, react_1.useState)(""), 2), countryCode = _c[0], setCountryCode = _c[1];
    var apiBaseUrl = (0, inversify_react_1.useInjection)("apiBaseUrl");
    var creator = (0, usePaymentGateways_1.usePaymentGateway)().creator;
    var countrySelectionHandler = function (countryCode) {
        setCountryCode(countryCode);
        telemetry.countrySelected(countryCode);
    };
    (0, react_1.useEffect)(function () {
        getCountryCode(apiBaseUrl).then(function (countryCode) { return countrySelectionHandler(countryCode); });
    }, []);
    var onboardingHandler = function () { return __awaiter(_this, void 0, void 0, function () {
        var createdPaymentGateway;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, creator({ countryCode: countryCode, defaultGateway: true })];
                case 1:
                    createdPaymentGateway = _a.sent();
                    return [4, OAuthWindow_1.default.show("".concat(apiBaseUrl, "/payments/gateway/").concat(createdPaymentGateway === null || createdPaymentGateway === void 0 ? void 0 : createdPaymentGateway.id, "/onboarding"), {
                            width: 900,
                            height: 1000,
                        })];
                case 2:
                    _a.sent();
                    closeModal();
                    return [2];
            }
        });
    }); };
    return (react_1.default.createElement(ModalContainer_1.ModalContainer, { show: showModal, onDismiss: closeModal },
        react_1.default.createElement(kaleidoscope_1.Layer, { offset: Configuration_1.modalZIndex }, function () { return (react_1.default.createElement(kaleidoscope_1.Stack, { className: styles.onboardingModal },
            react_1.default.createElement(kaleidoscope_1.Stack, { padding: "l", paddingBottom: "xxl", justify: "spaceBetween" },
                react_1.default.createElement(kaleidoscope_1.Stack, { justify: "spaceBetween", direction: "horizontal", align: "end" },
                    react_1.default.createElement("div", null, step != "initial" && (react_1.default.createElement(kaleidoscope_1.IconButton, { icon: react_1.default.createElement(icons_1.ArrowLeft, null), onClick: function () { return setStep("initial"); }, buttonState: kaleidoscope_1.ButtonState.Idle }))),
                    react_1.default.createElement(kaleidoscope_1.IconButton, { icon: react_1.default.createElement(icons_1.Close, null), onClick: closeModal, buttonState: kaleidoscope_1.ButtonState.Idle })),
                step == "initial" && (react_1.default.createElement(kaleidoscope_1.Stack, { gap: "xxxl", className: styles.modalBody, justify: "spaceBetween", paddingBottom: "xl" },
                    react_1.default.createElement(kaleidoscope_1.Heading, { level: "3", strong: true, className: styles.modalHeader, align: "center" },
                        "Connect QwilrPay",
                        react_1.default.createElement("br", null),
                        "to activate Payments"),
                    react_1.default.createElement(kaleidoscope_1.Stack, { gap: "m", align: "center" },
                        react_1.default.createElement(QwilrPayText, null),
                        react_1.default.createElement(kaleidoscope_1.Text, { className: styles.description, size: "s", align: "center" }, "QwilrPay is a seamless payment gateway powered by Stripe, enabling instant transactions directly within proposals.")),
                    react_1.default.createElement(kaleidoscope_1.Stack, { align: "center", direction: "vertical", gap: "l" },
                        react_1.default.createElement(kaleidoscope_1.Stack, { direction: "horizontal", gap: "s", className: styles.buttonsWrapper },
                            react_1.default.createElement(kaleidoscope_1.Button, { onClick: function () { }, type: kaleidoscope_1.ButtonType.Secondary, size: kaleidoscope_1.ButtonSize.Large, className: styles.onboardingButton },
                                react_1.default.createElement(icons_1.Video, null),
                                "Learn More"),
                            react_1.default.createElement(kaleidoscope_1.Button, { onClick: function () { return setStep("countrySelection"); }, type: kaleidoscope_1.ButtonType.Primary, size: kaleidoscope_1.ButtonSize.Large, className: styles.onboardingButton }, "Connect")),
                        react_1.default.createElement(kaleidoscope_1.Link, { href: "#" }, "Connect an existing Stripe account")))),
                step == "countrySelection" && (react_1.default.createElement(kaleidoscope_1.Stack, { gap: "xxxl", className: styles.modalBody, justify: "spaceBetween", paddingBottom: "xl" },
                    react_1.default.createElement(kaleidoscope_1.Heading, { level: "3", strong: true, className: styles.modalHeader, align: "center" },
                        "Confirm which part of",
                        react_1.default.createElement("br", null),
                        "the world you are in"),
                    react_1.default.createElement(kaleidoscope_1.Stack, { paddingLeft: "l", paddingRight: "l", align: "center" },
                        react_1.default.createElement(kaleidoscope_1.Layer, { offset: Configuration_1.modalZIndex + 1 }, function () { return (react_1.default.createElement(kaleidoscope_1.Select, { className: styles.countrySelector, placeholder: "Select a country", label: "Country", icon: countryCode && react_1.default.createElement(LocationFlag_1.LocationFlag, { countryCode: countryCode }), value: countryCode, onChange: function (code) {
                                setCountryCode(code);
                            }, autoStack: true }, Countries_1.countries
                            .sort(function (a, b) { return a.name.localeCompare(b.name); })
                            .map(function (_a) {
                            var name = _a.name, code = _a.code;
                            return (react_1.default.createElement(kaleidoscope_1.SelectOption, { icon: react_1.default.createElement(LocationFlag_1.LocationFlag, { countryCode: code.toUpperCase() }), key: code, value: code.toUpperCase() }, name));
                        }))); })),
                    react_1.default.createElement(kaleidoscope_1.Stack, { align: "center", direction: "vertical", gap: "l" },
                        react_1.default.createElement(kaleidoscope_1.Button, { onClick: function () { return onboardingHandler(); }, type: kaleidoscope_1.ButtonType.Primary, size: kaleidoscope_1.ButtonSize.Large, className: styles.onboardingButton }, "Continue"))))))); })));
}
exports.PaymentsOnboarding = PaymentsOnboarding;
var QwilrPayText = function () { return (react_1.default.createElement(kaleidoscope_1.Stack, { direction: "horizontal", gap: "xxxs", align: "center", justify: "center" },
    react_1.default.createElement(kaleidoscope_1.Text, { className: styles.first }, "Qwilr"),
    react_1.default.createElement(kaleidoscope_1.Text, { className: styles.last }, " Pay"))); };
var getCountryCode = function (apiBaseUrl) { return __awaiter(void 0, void 0, Promise, function () {
    var data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4, axios_1.default.get("".concat(apiBaseUrl, "/payments/gateway/country"), { withCredentials: true })];
            case 1:
                data = (_a.sent()).data;
                return [2, data];
        }
    });
}); };
